import React, { useEffect } from 'react'
import { connect } from 'react-redux'

export function PureBlockUI ({ text, hideLoading }) {
  useEffect(() => {
    document.body.classList.add('block-ui-body')
    return () => {
      document.body.classList.remove('block-ui-body')
    }
  }, [text])
  return (
    <div className='block-ui'>
      {!hideLoading && <div className='k-loading-image' />}
      <div className='block-ui-text'>{text}</div>
    </div>
  )
}

export const BlockUI = connect(state => state.blockUI)(({ show, text }) => show ? <PureBlockUI text={text} /> : null)



// WEBPACK FOOTER //
// ./src/components/blockUI.js